import { render, staticRenderFns } from "./PlayerWinStats.vue?vue&type=template&id=1efcd158&scoped=true"
import script from "./PlayerWinStats.vue?vue&type=script&lang=js"
export * from "./PlayerWinStats.vue?vue&type=script&lang=js"
import style0 from "./PlayerWinStats.vue?vue&type=style&index=0&id=1efcd158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efcd158",
  null
  
)

export default component.exports